'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _images_placeholder = require('../../../../../../static/images/images_placeholder.svg');var _images_placeholder2 = _interopRequireDefault(_images_placeholder);
var _displayPrice = require('../../../../../helpers/displayPrice');var _displayPrice2 = _interopRequireDefault(_displayPrice);
var _CellGallery = require('../CellGallery/CellGallery');var _CellGallery2 = _interopRequireDefault(_CellGallery);
var _CellGalleryWithDotsPagination = require('../CellGallery/CellGalleryWithDotsPagination');var _CellGalleryWithDotsPagination2 = _interopRequireDefault(_CellGalleryWithDotsPagination);
var _modifyImageLink = require('../../../../../utils/modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _constants = require('../../../../../constants');

var _CellPhotoBlock = require('./CellPhotoBlock.scss');var styles = _interopRequireWildcard(_CellPhotoBlock);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Modules

var renderPrice = function renderPrice(data) {return (0, _displayPrice2.default)(data, styles);}; // Styles
// Helpers
var renderFavoriteIcon = function renderFavoriteIcon(props) {
  var handleToggleFavorite = function handleToggleFavorite(evt) {
    evt.stopPropagation();
    props.toggleFavorite(evt);
  };

  return !props.showManagePropertiesPack &&
  _react2.default.createElement('span', {
      onClick: handleToggleFavorite,
      className: (0, _classnames2.default)(
      styles.favoriteIcon,
      'favoriteToggler',
      props.isFavorite ? 'icon-favorite-active-with-border' : 'icon-favorite-disabled') },


    _react2.default.createElement('span', { className: 'path1 favoriteToggler' }),
    _react2.default.createElement('span', { className: 'path2 favoriteToggler' }));


};

var renderVRIcon = function renderVRIcon(hasVRLink) {return hasVRLink &&
  _react2.default.createElement('span', { className: (0, _classnames2.default)(styles.labelVR, 'icon', 'icon-vr-view') },
    _react2.default.createElement('span', { className: 'path1' }),
    _react2.default.createElement('span', { className: 'path2' }),
    _react2.default.createElement('span', { className: 'path3' }),
    _react2.default.createElement('span', { className: 'path4' }),
    _react2.default.createElement('span', { className: 'path5' }));};



var renderGallery = function renderGallery(photo, images, videoPoster, isRtl, isLazy, isHomePageSlider,
withoutRealEstateSlider, withoutLoop, withoutPagination, withDotsPagination) {
  if (images && images.length > 1) {
    var GalleryComponent = withDotsPagination ? _CellGalleryWithDotsPagination2.default : _CellGallery2.default;
    return (
      _react2.default.createElement(GalleryComponent, {
        images: images,
        isRtl: isRtl,
        withoutLoop: withoutLoop,
        withoutPagination: withoutPagination,
        isLazy: isLazy,
        withoutRealEstateSlider: withoutRealEstateSlider }));


  }

  if (videoPoster) {
    return (
      _react2.default.createElement('img', {
        alt: 'video poster',
        property: 'photo',
        src: videoPoster }));


  }

  var modifiedImage = (0, _modifyImageLink2.default)(photo, _constants.imageModifierTypes.GALLERY_THUMBNAIL) || _images_placeholder2.default;
  var modifiedImageMobile = (0, _modifyImageLink2.default)(photo, _constants.imageModifierTypes.GALLERY_THUMBNAIL_MOBILE) || _images_placeholder2.default;

  return (
    _react2.default.createElement('img', {
      alt: '',
      property: 'photo',
      srcSet: '\n        ' +
      modifiedImage + ' 350w,\n        ' +
      modifiedImageMobile + ' 600w\n      ',

      sizes: '(max-width: 767px) 600px, (min-width: 768px) 350px',
      src: modifiedImage }));


};

var renderStatusIcon = function renderStatusIcon(active) {return (
    _react2.default.createElement('div', { className: styles.statusCell },
      _react2.default.createElement('i', { className: 'icon icon-' + (active ? 'active' : 'inactive') }, _react2.default.createElement('i', { className: 'path1' }), _react2.default.createElement('i', { className: 'path2' }))));};



var CellPhotoBlock = function CellPhotoBlock(props) {return (
    _react2.default.createElement('div', {
        className: (0, _classnames2.default)(
        styles.propertyCellPhotoBlock,
        props.classNameProperty,
        props.additionalClassName ? styles[props.additionalClassName] : null,
        styles[props.className]),

        ref: props.innerRef || function () {} },

      props.showManagePropertiesPack && renderStatusIcon(props.active),
      renderVRIcon(props.hasVRLink),
      !props.withoutFavorite && !props.isMyProject && renderFavoriteIcon(props),
      renderGallery(props.photo, props.images, props.videoPoster, props.isRtl, props.isLazy, props.isHomePageSlider,
      props.withoutRealEstateSlider, props.withoutLoop, props.withoutPagination, props.withDotsPagination),
      !props.withoutPrice && renderPrice(props)));};



CellPhotoBlock.propTypes = {
  innerRef: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  photo: _propTypes2.default.string,
  images: _propTypes2.default.array,
  videoPoster: _propTypes2.default.string,
  price: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  isRtl: _propTypes2.default.bool,
  showManagePropertiesPack: _propTypes2.default.bool,
  toggleFavorite: _propTypes2.default.func,
  isFavorite: _propTypes2.default.bool,
  classNameProperty: _propTypes2.default.string,
  additionalClassName: _propTypes2.default.string,
  hasVRLink: _propTypes2.default.bool,
  active: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  isDynamic: _propTypes2.default.bool,
  isLazy: _propTypes2.default.bool,
  isHomePageSlider: _propTypes2.default.bool,
  withoutRealEstateSlider: _propTypes2.default.bool,
  withoutPrice: _propTypes2.default.bool,
  isMyProject: _propTypes2.default.bool,
  withoutFavorite: _propTypes2.default.bool,
  withoutCurrency: _propTypes2.default.bool,
  withoutLoop: _propTypes2.default.bool,
  withoutPagination: _propTypes2.default.bool,
  currency: _propTypes2.default.object,
  withDotsPagination: _propTypes2.default.bool,
  priceClassName: _propTypes2.default.string };exports.default =


CellPhotoBlock;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMPropertyCells/components/CellPhotoBlock/CellPhotoBlock.js
// module id = 142
// module chunks = 0